import React, { useState, useRef, useEffect } from "react";
import { Globe, ChevronDown } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

export default function LanguageSelector() {
  const { lang, setLang, languages, t } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const current = languages.find((l) => l.code === lang) || languages[0];

  return (
    <div className="vls-lang" ref={ref}>
      <button
        type="button"
        className="vls-lang-btn"
        onClick={() => setOpen((v) => !v)}
        data-testid="language-selector-button"
        aria-label={t("chooseLanguage")}
      >
        <Globe size={16} />
        <span className="vls-lang-flag">{current.flag}</span>
        <span className="vls-lang-label">{current.label}</span>
        <ChevronDown size={14} className={`vls-lang-chevron ${open ? "open" : ""}`} />
      </button>
      {open && (
        <ul className="vls-lang-menu" role="listbox" data-testid="language-selector-menu">
          {languages.map((l) => (
            <li key={l.code}>
              <button
                type="button"
                className={`vls-lang-item ${l.code === lang ? "active" : ""}`}
                onClick={() => {
                  setLang(l.code);
                  setOpen(false);
                }}
                data-testid={`language-option-${l.code}`}
                role="option"
                aria-selected={l.code === lang}
              >
                <span className="vls-lang-flag">{l.flag}</span>
                <span>{l.label}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
